import axios from 'axios';
const baseUrl = process.env.REACT_APP_baseUrl;

const noAuthRoutes = ['auth/login', 'auth/register', 'auth/forgot/verifyotp', 'auth/verify/otp', 'auth/resend/otp', 'auth/forgot'];

async function apiServiceHandler(method, endpoint, payload) {
  const token = localStorage.getItem('STG_TOKEN');
  const requiresAuth = !noAuthRoutes.some(route => endpoint.includes(route));

  try {
    let response;
    const headers = requiresAuth
      ? { 'Authorization': 'Bearer ' + token }
      : {};

    if (method === 'GET') {
      response = await axios({
        method: 'get',
        url: `${baseUrl}/${endpoint}`,
        headers: headers,
      });
    } else if (method === 'POST') {
      response = await axios({
        method: 'post',
        url: `${baseUrl}/${endpoint}`,
        headers: headers,
        data: payload,
      });
    } else if (method === 'PUT') {
      response = await axios({
        method: 'put',
        url: `${baseUrl}/${endpoint}`,
        headers: headers,
        data: payload,
      });
    } else if (method === 'PATCH') {
      response = await axios({
        method: 'patch',
        url: `${baseUrl}/${endpoint}`,
        headers: headers,
        data: payload,
      });
    } else if (method === 'DELETE') {
      response = await axios({
        method: 'delete',
        url: `${baseUrl}/${endpoint}`,
        headers: headers,
        data: payload,
      });
    } else {
      throw new Error('Unsupported HTTP method');
    }

    return response.data;
  } catch (error) {
    throw error;
  }
}

export default apiServiceHandler;
